import { type TRANSLATION_LOCALES, $i18n_state } from "../SHARED/i18n";

const en = {
	welcome: {
		start: "Congratulations",
		end: "For Participating in Designathon 2025!",
	},
	caution: "some browsers will refuse to download files directly.",
	attendance: {
		label: "attendance certificate",
		button: "certificate",
	},
	top10: {
		label: "shortlisted certificate",
		button: "certificate",
	},
	top3: {
		label: "winner certificate",
		button: "certificate",
	},
	guinness: {
		label:
			"Certificate of your Participation in Achieving a Guinness World Record",
		button: "certificate",
	},
};
const translations: Record<TRANSLATION_LOCALES, TRANSLATION_SCHEMA> = {
	en,
	ar: {
		welcome: {
			start: "تهانينا",
			end: "لمشاركتك في ديزايناثون 2025",
		},
		caution: "سترفض بعض المتصفحات تنزيل الملفات مباشرةً.",
		attendance: {
			label: "شهادة الحضور",
			button: "الشهادة",
		},
		top10: {
			label: "شهادة المتأهلين",
			button: "الشهادة",
		},
		top3: {
			label: "شهادة الفائزين",
			button: "الشهادة",
		},
		guinness: {
			label: "شهادة مشاركتكم في تحقيق رقم قياسي في موسوعة جينيس",
			button: "الشهادة",
		},
	},
};

export type TRANSLATION_SCHEMA = typeof en;
export const t = () => {
	return translations[$i18n_state.value];
};
